import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, BoxplotChart, CustomChart, LineChart, HeatmapChart, RadarChart, SankeyChart, ScatterChart } from 'echarts/charts'
import { TooltipComponent, GridComponent, LegendComponent, RadarComponent, VisualMapComponent } from 'echarts/components'

use([CanvasRenderer, BarChart, BoxplotChart, CustomChart, LineChart, HeatmapChart, RadarChart, SankeyChart, ScatterChart, TooltipComponent, GridComponent, LegendComponent, RadarComponent, VisualMapComponent])
